@for (kind of kinds(); track $index; let i = $index; let last = $last) {<span
  #seg
  class="sb-dt__seg"
  [class.sb-dt__seg--period]="kind === 'period'"
  [attr.id]="segIds()[i]"
  [attr.role]="segRole()"
  [attr.tabindex]="disabled() ? -1 : 0"
  [attr.inputmode]="segInputMode(i)"
  enterkeyhint="done"
  spellcheck="false"
  autocorrect="off"
  autocapitalize="off"
  [attr.aria-label]="segName(i)"
  [attr.aria-labelledby]="segLabelledBy(i)"
  [attr.aria-valuenow]="ariaValueNow(i)"
  [attr.aria-valuemin]="ariaBounds(i)?.[0] ?? null"
  [attr.aria-valuemax]="ariaBounds(i)?.[1] ?? null"
  [attr.aria-valuetext]="ariaValueText(i)"
  [attr.aria-invalid]="segInvalid(i) ? 'true' : null"
  [attr.aria-readonly]="readonly() ? 'true' : null"
  [attr.aria-disabled]="disabled() ? 'true' : null"
  [attr.aria-required]="required() ? 'true' : null"
  [attr.aria-describedby]="segDescribedBy(i)"></span>@if (!last) {<span #lit class="sb-dt__lit" aria-hidden="true"></span>}}<span
  #kept
  class="sb-dt__kept"
  role="textbox"
  aria-multiline="false"
  inputmode="numeric"
  enterkeyhint="done"
  hidden
  [attr.tabindex]="disabled() ? -1 : 0"
  spellcheck="false"
  [attr.aria-labelledby]="nameId() || null"
  [attr.aria-label]="nameId() ? null : name() || null"
  [attr.aria-readonly]="readonly() ? 'true' : null"
  [attr.aria-describedby]="keptDescribedBy()"></span>
